module.exports = __webpack_public_path__ + "static/media/PY.1a604331.svg";